<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row >
          <v-col justify="center" class="ma-0 pa-0">
            <v-card class="ma-0 pa-0" flat>
              <v-card-title class="justify-center headline font-weight-black" dense>
                <span class="blue--text text--darken-4 mb-4">Mishap Reporting Process</span>
              </v-card-title>
              <v-card-text class="text-center">
                <v-img class="centerImage" eager src="../assets/MishapReporting.png" width="100px"/>
                <br />
                <br />
                <label class="font-weight-black red--text text--darken-4 display-1">{{ mobileString }}</label>
                <br />
                <br />
                <div v-for="item in digits" v-bind:key="item.digit">
                  <label class="font-weight-black black--text subtitle-1">Press {{item.digit}} for {{item.state}}</label><br />
                </div>
                <br />
              </v-card-text>

              <v-layout justify-center>
                <v-card-actions>
                  <v-btn width="100" :href="`tel:+1${ mobile }`" class="white--text" color="red darken-4" rounded>Call Now</v-btn>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </v-card-actions>
              </v-layout>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MishapReport',
  components: {
  },
  data() {
    return {
      mobile:'8337277233',
      mobileString: '833-727-7233',
      digits:[
        {
          digit: 1,
          state: 'ALASKA'
        },
        {
          digit: 2,
          state: 'CALIFORNIA'
        },
        {
          digit: 3,
          state: 'HAWAII'
        },
        {
          digit: 4,
          state: 'NEVADA'
        },
        {
          digit: 5,
          state: 'OREGON'
        },
        {
          digit: 6,
          state: 'WASHINGTON'
        },
        {
          digit: 700,
          state: 'PACIFIC REGION'
        },
      ]
    }
  },
  mounted() {
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  }
}

</script>

<style scoped>
.centerImage {
  margin: auto;
}
</style>
